<!-- Alerts Start-->
<div class="btn-group alerts">
  <button type="button" data-qa="gn-alert" class="btn btn-primary dropdown-toggle1 noborder"
    data-toggle="dropdown" aria-expanded="false" [attr.aria-haspopup]="alertLinks.length > 0 ? 'true' : null">
    <span class="fa fa-bell" aria-hidden="true"></span>
    <gn-alert-count [domain]="domain"></gn-alert-count>
  </button>
  <div class="dropdown-menu dropdown-menu-right dropdown-alert color-scheme-white">
    <div class="dropdown-alert-heading p-3">
      <h2 class="h4 mt-0">
        <span class="fa fa-bell"></span> Alerts</h2>
    </div>
    <div class="dropdown-alert-body">
      <div [hidden]='!alertsLoading' class="text-center margin-top-20 margin-bottom-20">
        <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <ul class="dropdown-alerts-list" role="menu">
        <li *ngFor="let alertItem of alertLinks | slice:0:5">
          <gn-alert-item [alert]="alertItem" [alertsUrl]="alertsUrl" (dismissClicked)='onDissmissClick($event)'></gn-alert-item>
        </li>
      </ul>
      <div *ngIf="alertError">
        <gn-alert-error [errorMessage]="errorMessage" [alertsUrl]="alertsUrl"></gn-alert-error>
      </div>

    </div>

    <div *ngIf="!alertError" class="dropdown-alert-footer">
      <a [href]="alertsUrl" class="btn btn-link btn-block">View All</a>
    </div>
  </div>
</div>
<!-- Alerts End-->
